import { FC } from 'react';
import {
  ProgramActivityDataFragment,
  UserType,
} from '../../../generated/graphql';
import { isProgramActivityMultiSignatureForm } from '../../lib/programActivity';
import VerticalSignatureStatus from '../SignatureStatus/VerticalSignatureStatus';
import SignatureSummary from '../SignatureStatus/SignatureSummary';

interface VerticalSignatureDisplayProps {
  programActivity: ProgramActivityDataFragment;
  className?: string;
  forceFullDisplay?: boolean; // Force full display (for sidebars)
  authedProviderUserId?: string;
  context?: 'mail' | 'activities'; // Context for tooltip positioning
  userType?: UserType;
}

const VerticalSignatureDisplay: FC<VerticalSignatureDisplayProps> = ({
  programActivity,
  className,
  forceFullDisplay = false,
  authedProviderUserId,
  context = 'activities', // Default to activities
  userType = UserType.ProviderUser,
}) => {
  if (!isProgramActivityMultiSignatureForm(programActivity)) {
    return null;
  }

  const signatureUsers =
    programActivity.programAssessment?.programAssessmentSignatureUsers || [];
  const currentSignerId = programActivity.programAssessment?.currentSigner?.id;

  // Closed summary for list views when not forced to show full
  if (!forceFullDisplay) {
    return (
      <SignatureSummary
        programActivity={programActivity}
        className={className}
        context={context}
        authedProviderUserId={authedProviderUserId}
        userType={userType}
      />
    );
  }

  // Use full vertical display for active forms, forms with pending signatures, or when forced
  return (
    <VerticalSignatureStatus
      signatureUsers={signatureUsers}
      currentSignerId={currentSignerId}
      className={className}
      showStatus={true}
      showNames={true}
    />
  );
};

export default VerticalSignatureDisplay;
